(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { useState } from 'react';
import { FormGroup, FormControl, FormLabel } from '@material-ui/core';
import PropTypes from 'prop-types';
import Checkbox from "./Checkbox.js";

var CheckboxGroup = function CheckboxGroup(props) {
  var options = props.options,
      value = props.value,
      onChange = props.onChange,
      label = props.label,
      color = props.color;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      checkedOptions = _useState2[0],
      setCheckedOptions = _useState2[1];

  var handleChange = function handleChange(value) {
    return function (e) {
      var newValue;

      if (e.target.checked) {
        newValue = [].concat(_toConsumableArray(checkedOptions), [value]);
      } else {
        newValue = checkedOptions.filter(function (item) {
          return item !== value;
        });
      }

      setCheckedOptions(newValue);
      onChange(e, newValue);
    };
  };

  return React.createElement(FormControl, {
    component: "fieldset"
  }, label ? React.createElement(FormLabel, {
    component: "legend"
  }, label) : null, React.createElement(FormGroup, null, options.map(function (option) {
    return React.createElement(Checkbox, {
      key: option.value,
      label: option.label,
      checked: checkedOptions.includes(option.value),
      onChange: handleChange(option.value),
      color: color,
      disabled: option.disabled
    });
  })));
};

__signature__(CheckboxGroup, "useState{[checkedOptions, setCheckedOptions](value)}");

CheckboxGroup.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool
  })),
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),
  direction: PropTypes.oneOf(['column'])
};
CheckboxGroup.defaultProps = {
  options: [],
  value: [],
  onChange: function onChange() {
    return console.warn('No onChange function is provided');
  },
  color: 'default',
  direction: 'column'
};
var _default = CheckboxGroup;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CheckboxGroup, "CheckboxGroup", "/home/vsts/work/1/s/src/components/inputs/CheckboxGroup.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/inputs/CheckboxGroup.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();